import { createFileRoute } from '@tanstack/react-router';
import { DataIndexCatchAllRedirect } from '@/pages/workspaces/data-index/routing';
import { LastWorkspaceResolver } from './-route-helpers';

function DataIndexSplatRoute() {
  return (
    <LastWorkspaceResolver>
      <DataIndexCatchAllRedirect />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/data-index/$')({
  component: DataIndexSplatRoute,
});
